var map = {
	"./Academic.svg": 5089,
	"./Arts and Music.svg": 2052,
	"./Charity and Fundraising.svg": 7685,
	"./Crafts and Hobbies.svg": 3574,
	"./Environment and Nature.svg": 3957,
	"./Faith.svg": 468,
	"./Fiction and Fantasy.svg": 2761,
	"./Food and Drink.svg": 1409,
	"./Health and Wellbeing.svg": 8456,
	"./Languages and Culture.svg": 8876,
	"./Media and Broadcasting.svg": 7166,
	"./Other.svg": 2150,
	"./Political and Activism.svg": 428,
	"./Skills and Employability.svg": 1833,
	"./Sport.svg": 7182,
	"./Technology and Gaming.svg": 7408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8488;